export interface CountryRulesV2 {
  minLimitToSchedule: number;
  customerReminder: number;
  minDayToSchedule: number;
  minDayToScheduleCommercialVehicle: number;
  allowBackwardSchedule: boolean;
  allowFordProtect: boolean;
  allowPickUpAndDelivery: boolean;
  allowChecklist: boolean;
  allowBudget: boolean;
  allowVehicleImage: boolean;
  allowFmaLogin: boolean;
  minHourSchedulePD: number;
  maxHourSchedulePD: number;
  intervalHourSchedulePD: number;
  allowWhatsAppContact: boolean;
  countryTaxRate: number;
  minDayToSchedulePud: number;
  minDayToScheduleMsv: number;
}
